import React, { useState, useEffect } from 'react';
import { Button, message } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from '../constants/api';
import { VoucherTable, VoucherModal } from './VoucherCommon';
import SearchBar from './common/SearchBar';
import { useDebounce } from 'use-debounce';

const VoucherDebits = () => {
  const [vouchers, setVouchers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingVoucher, setEditingVoucher] = useState(null);
  const [form] = Form.useForm();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [debouncedSearchTerm] = useDebounce(searchTerm, 300);

  useEffect(() => {
    fetchVouchers();
    fetchAccounts();
  }, []);

  useEffect(() => {
    if (debouncedSearchTerm) {
      fetchVouchers(debouncedSearchTerm);
    } else {
      fetchVouchers();
    }
  }, [debouncedSearchTerm]);

  const fetchVouchers = async (query = '') => {
    setSearchLoading(true);
    try {
      const params = { Type: 1 };
      if (query) params.AccountName = query;
      const response = await axios.get(`${API_BASE_URL}Voucher/List`, { params });
      if (response.data.code === 0) {
        setVouchers(response.data.data || []);
      } else {
        message.error('فشل في تحميل البيانات');
      }
    } catch (error) {
      message.error('خطأ في تحميل البيانات');
    }
    setSearchLoading(false);
    setLoading(false);
  };

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}Account/List`);
      if (response.data.code === 0) {
        setAccounts(response.data.data);
      } else {
        message.error('فشل في جلب الحسابات');
      }
    } catch (error) {
      message.error('خطأ في جلب الحسابات');
    }
  };

  const handleCreate = () => {
    setEditingVoucher(null);
    form.resetFields();
    form.setFieldsValue({ Type: 1, DebitAccountId: 111 });
    setIsModalVisible(true);
  };


  const handleEdit = (record) => {
    setEditingVoucher(record);
    form.setFieldsValue(record);
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}Voucher/Delete/${id}`);
      if (response.data.code === 0) {
        message.success('تم حذف القيد بنجاح');
        fetchVouchers();
      } else {
        message.error('فشل في حذف القيد');
      }
    } catch (error) {
      message.error('خطأ في حذف القيد');
    }
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingVoucher) {
        // Update functionality would be implemented here
        message.info('Update voucher functionality would be implemented here');
      } else {
        const response = await axios.post(`${API_BASE_URL}Voucher/Create`, values);
        if (response.data.code === 0) {
          message.success('تم إنشاء القيد بنجاح');
        } else {
          message.error('فشل في إنشاء القيد');
        }
      }
      setIsModalVisible(false);
      fetchVouchers();
    } catch (error) {
      message.error('خطأ في حفظ القيد');
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
          إضافة
        </Button>
        <SearchBar
          onSearch={setSearchTerm}
          loading={searchLoading}
          placeholder="ابحث بالحساب..."
        />
      </div>
      <VoucherTable
        dataSource={vouchers}
        loading={loading || searchLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        locale={{ emptyText: searchTerm ? 'لا توجد قيود بهذا الحساب' : 'لا توجد قيود' }}
      />
      <VoucherModal
        isVisible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        editingVoucher={editingVoucher}
        form={form}
        accounts={accounts}
        fixedType={1}
      />
    </div>
  );
};

export default VoucherDebits;
